import { render, staticRenderFns } from "./addTravelSpecs.vue?vue&type=template&id=37a794c0&scoped=true&"
import script from "./addTravelSpecs.vue?vue&type=script&lang=js&"
export * from "./addTravelSpecs.vue?vue&type=script&lang=js&"
import style0 from "./addTravelSpecs.vue?vue&type=style&index=0&id=37a794c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a794c0",
  null
  
)

export default component.exports